var map = {
	"./avatar-s-11.jpg": "3f31",
	"./professor_avatar.png": "4043",
	"./user01.png": "7116",
	"./user02.png": "0302",
	"./user03.png": "4728",
	"./user04.png": "f299",
	"./user05.png": "44b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "60db";